import { render } from "./localeSwitcher.vue?vue&type=template&id=71f3bc88"
import script from "./localeSwitcher.vue?vue&type=script&lang=js"
export * from "./localeSwitcher.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__